import React from 'react';
import PropTypes from 'prop-types';
import { useUserContext } from 'context';
import PoiEditForm from 'components/PoiEditForm';

const VenueProfile = props => {
  const { producerQuotas = [] } = useUserContext();
  const activeId = producerQuotas.find(pq => pq.isCurrentActive)?.poi.id;

  return <PoiEditForm key={activeId} poiId={activeId} {...props} />;
};

VenueProfile.propTypes = {
  regionChoices: PropTypes.arrayOf(PropTypes.array),
  timezoneChoices: PropTypes.arrayOf(PropTypes.array),
  mapboxToken: PropTypes.string,
  poiTypeChoices: PropTypes.arrayOf(PropTypes.array),
};

export default VenueProfile;
